import { Routes, Route } from 'react-router-dom';
import GaletteDesRois from './pages/GaletteDesRois';

function App() {
  return (
    <Routes>
      <Route path="/" element={<GaletteDesRois />} />
    </Routes>
  );
}

export default App;